import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { PAGES_PATH } from '@app/shared/constants/routes';
import { NavigateService } from '@app/shared/services/navigate/navigate.service';

@Injectable({ providedIn: 'root' })
export class GlobalRouteGuard {
  public constructor(
    private router: Router,
    public navigateService: NavigateService,
  ) {}

  // This guard is used to prevent the user from accessing the application
  // without verifying their site token.
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    if (state.url !== `/${PAGES_PATH.Verify}`) {
      const navigateBackUrl: string = NavigateService.getNavigateUrl(state.url);
      this.navigateService.navigateToPage(navigateBackUrl, PAGES_PATH.Verify);

      return false;
    }

    return true;
  }
}
